import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=55aaa60f&scoped=true&"
import script from "./ButtonWidget.vue?vue&type=script&lang=js&"
export * from "./ButtonWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aaa60f",
  null
  
)

export default component.exports